// src/pages/NotFoundPage.js
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navbar from '../components/Navbar';

export default function NotFoundPage() {
  const { t } = useTranslation();

  return (
    <div className="page">
      <Navbar />
      <div className="container" style={{ paddingTop: 60, paddingBottom: 60, textAlign: 'center' }}>
        <div style={{ fontSize: '3.5rem', marginBottom: 16 }}>{t('notFound.code')}</div>
        <h1 style={{ fontSize: '1.4rem', marginBottom: 8 }}>{t('notFound.title')}</h1>
        <p style={{ color: 'var(--muted)', fontSize: '0.88rem', marginBottom: 28, lineHeight: 1.6 }}>
          {t('notFound.subtitle')}
        </p>
        <Link to="/" className="btn btn-primary" style={{ maxWidth: 280, margin: '0 auto 10px' }}>
          {t('notFound.goHome')}
        </Link>
        <Link to="/dashboard" className="btn btn-secondary" style={{ maxWidth: 280, margin: '0 auto' }}>
          {t('notFound.myDashboard')}
        </Link>
      </div>
    </div>
  );
}
